import { render, staticRenderFns } from "./SentTickets.vue?vue&type=template&id=2bcfab25&"
import script from "./SentTickets.vue?vue&type=script&lang=js&"
export * from "./SentTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports